import { render, staticRenderFns } from "./hotdeals.vue?vue&type=template&id=4bf78874&scoped=true"
import script from "./hotdeals.vue?vue&type=script&lang=js"
export * from "./hotdeals.vue?vue&type=script&lang=js"
import style0 from "./hotdeals.vue?vue&type=style&index=0&id=4bf78874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf78874",
  null
  
)

export default component.exports